import React from 'react';
import {Content, Container, EventInformation, DataContainer} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Line, Typography} from '@fupa/fupa-uikit';
import {StreamIcon} from 'app/styles/stream';
import PropTypes from 'prop-types';
import {Whatshot} from '@mui/icons-material';

const RMTFact = ({fact}) => {
  return (
    <Content>
      <Container>
        <EventInformation>
          <StreamIcon color={COLORS.orangeSoda}>
            <Whatshot style={{color: COLORS.white, fontSize: 20}} />
          </StreamIcon>
        </EventInformation>
        <DataContainer>
          <Typography variant='body1'>Top-Fakt 🚀</Typography>
          <Typography variant='body2'>{fact}</Typography>
        </DataContainer>
      </Container>
      <Line />
    </Content>
  );
};

RMTFact.propTypes = {
  fact: PropTypes.string.isRequired,
};

export {RMTFact};
